import AseanBusinessVertical from "@routes/Section/layouts/Verticals/AseanBusiness/AseanBusinessVertical";
import GlobalEnterpriseVertical from "@routes/Section/layouts/Verticals/GlobalEnterprise/GlobalEnterpriseVertical";
import SMEVertical from "@routes/Section/layouts/Verticals/SME/SMEVertical";
import { VerticalName } from "@util/constant";

/** Layout factory for verticals. */
export const VerticalLayoutFactory = (verticalName: VerticalName) => {
  switch (verticalName) {
    case "asean":
      return AseanBusinessVertical;

    case "sme":
      return SMEVertical;

    case "ge":
      return GlobalEnterpriseVertical;
  }
};

/**
 * Helper function to get the vertical name from the section unique name.
 *
 * @param sectionUniqueName The section unique name.
 * @returns {VerticalName | undefined} The vertical name.
 * */
export const getVerticalNameFromUniqueName = (
  sectionUniqueName: string
): VerticalName | undefined => {
  switch (sectionUniqueName) {
    case "international_asean":
      return "asean";

    case "singapore_smes":
      return "sme";

    case "international_global":
      return "ge";

    case "esg":
      return "esg";

    default:
      return;
  }
};

/**
 * Helper function to pull an array of keywords string to be used in query.
 *
 * @param verticalName The verticals name.
 * @returns {string[]}
 */
export const verticalsKeywordToPull = (
  verticalName: VerticalName | undefined
): string[] => {
  switch (verticalName) {
    case "garage":
      return ["/keywords/5-questions", "/keywords/startup-funding"];

    case "asean":
      return ["/keywords/asean"];

    case "sme":
      return ["/keywords/singapore-smes"];

    case "ge":
      return ["/keywords/asia-pacific"];

    case "esg":
    default:
      return [];
  }
};
